import React from 'react'
import styles from './index.module.less'

interface ProductPriceProps {
  /**最小价格 */
  minPrice?: number
  /**最大价格 */
  maxPrice?: number
}
export default function ProductPrice({
  minPrice,
  maxPrice,
}: ProductPriceProps) {
  return (
    <div className={styles.price}>
      <Price minPrice={minPrice} maxPrice={maxPrice} />
    </div>
  )
}

const Price = ({ minPrice, maxPrice }) => {
  if (!minPrice || !maxPrice) {
    return (
      <>
        <span>¥</span>
        {minPrice?.toFixed(2)} || <span>¥</span>
        {maxPrice?.toFixed(2)}
      </>
    )
  }

  if (minPrice === maxPrice) {
    return (
      <>
        <span>¥</span>
        {minPrice.toFixed(2)}
      </>
    )
  }

  if (!minPrice && !maxPrice) {
    return (
      <>
        <span>¥</span>0.00
      </>
    )
  }
  return (
    <>
      <span>¥</span>
      {minPrice?.toFixed(2)} - <span>¥</span>
      {maxPrice?.toFixed(2)}
    </>
  )
}
